module.exports = __webpack_public_path__ + "img/fournisseurVueParFamille.fb2bbde1.png";